const updateAreasStr = {
  toastrSuccess: 'Departamento actualizado',
  toastrSuccess2: ' fue actualizada con éxito',
  toastrError: 'Departamento ya registrado',
  toastrError1: 'Introduzca otro nombre'
};

export default updateAreasStr;
